import { ClaimSolutionEnum, ClaimStatusEnum } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getClaimResolveSchema = () => {
	return z.object({
		finalSolution: z.nativeEnum(ClaimSolutionEnum).nullish(),
		status: z.literal(ClaimStatusEnum.resolved),
		dateResolved: z.string().nullish(),
	});
};

export type ClaimResolveFormModel = z.infer<
	ReturnType<typeof getClaimResolveSchema>
>;
